@if (type() === 'password') {
<div class="relative w-full">
  <input
    [type]="passwordVisible() ? 'text' : 'password'"
    [id]="inputId()"
    [placeholder]="placeholder()"
    [formControl]="control()"
    [class]="inputClasses()"
  />
  <button
    type="button"
    class="absolute right-0 top-0 h-full px-4 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors flex items-center justify-center"
    (click)="togglePasswordVisibility()"
    [attr.aria-label]="passwordVisible() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
  >
    <span class="material-icons text-[14px] cursor-pointer"
      >{{ passwordVisible() ? 'visibility' : 'visibility_off' }}</span
    >
  </button>
</div>
} @else { @if (icon()) {
<div class="relative w-full">
  <input
    [type]="type()"
    [id]="inputId()"
    [placeholder]="placeholder()"
    [formControl]="control()"
    [class]="inputClasses()"
  />
  <span
    class="material-symbols-outlined absolute top-1/2 -translate-y-1/2 select-none pointer-events-none"
    [class.left-4]="iconPosition() === 'left'"
    [class.right-4]="iconPosition() === 'right'"
    [ngClass]="iconClasses()"
  >
    {{ icon() }}
  </span>
</div>
} @else {
<input
  [type]="type()"
  [id]="inputId()"
  [placeholder]="placeholder()"
  [formControl]="control()"
  [class]="inputClasses()"
/>
} }
